import React from 'react';
import cx from 'classnames';
import styles from './MuiIcon.module.scss';
import urlJoin from 'url-join';
import {CDN_IMAGE_URL} from 'configs';

const SOCIAL_ICONS = {
  youtube: {
    light: urlJoin(CDN_IMAGE_URL, 'icons/youtube-light.svg'),
    dark: urlJoin(CDN_IMAGE_URL, 'icons/youtube-dark.svg'),
  },
  x: {
    light: urlJoin(CDN_IMAGE_URL, 'icons/x-light.svg'),
    dark: urlJoin(CDN_IMAGE_URL, 'icons/x-dark.svg'),
  },
  linkedin: {
    light: urlJoin(CDN_IMAGE_URL, 'icons/linkedin-light.svg'),
    dark: urlJoin(CDN_IMAGE_URL, 'icons/linkedin-dark.svg'),
  },
};

function MuiIcon(props) {
  const {
    name,
    variant,
    className,
    spin,
    social,
    accent,
    size = 'md',
    symbol = false,
    ...rest
  } = props;

  let baseClass = symbol ? 'material-symbols' : 'material-icons';

  const baseClassName = baseClass.concat(variant ? `-${variant}` : '');

  if (social && accent) {
    return <img src={SOCIAL_ICONS[name][accent]} alt={name} {...rest} />;
  }

  return (
    <span
      className={cx(baseClassName, styles['mui-icon'], 'notranslate', {
        [styles['mui-icon--spin']]: spin,
        [styles[`mui-icon--${size}`]]: !!size,
        [className]: !!className,
      })}
      {...rest}
    >
      {name}
    </span>
  );
}

export default MuiIcon;
